import React from 'react';
import { Link } from 'react-router-dom';
import { SUBJECT_ROUTES } from '../../constants/routes';

interface GradeSelectionProps {
  grade: number;
  basePath: string;
}

export const GradeSelection: React.FC<GradeSelectionProps> = ({
  grade,
  basePath,
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '2rem',
      padding: '2rem',
      width: '100%',
      maxWidth: '800px',
    }}>
      <div style={{
        fontSize: 'clamp(2rem, 5vw, 3rem)',
        fontWeight: 'bold',
        color: '#66b3ff',
        marginBottom: '1rem',
      }}>
        {grade} клас
      </div>
      <div style={{
        display: 'flex',
        gap: '1.5rem',
        flexWrap: 'wrap',
        justifyContent: 'center',
      }}>
        <Link 
          to={`${basePath}/${SUBJECT_ROUTES.NATIONAL_DEFENSE}`}
          style={{
            padding: '1.75rem 2.75rem',
            background: 'linear-gradient(135deg, #0057B8 0%, #FFD700 100%)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '12px',
            fontWeight: '600',
            fontSize: '1.3rem',
            border: '2px solid rgba(255, 215, 0, 0.3)',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(255, 215, 0, 0.3)',
            minWidth: '200px',
            textAlign: 'center',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 215, 0, 0.5)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 215, 0, 0.3)';
          }}
        >
          Група юнаків
        </Link>
        <Link 
          to={`${basePath}/${SUBJECT_ROUTES.MEDICINE}`}
          style={{
            padding: '1.75rem 2.75rem',
            background: 'linear-gradient(135deg, #0057B8 0%, #FFD700 100%)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '12px',
            fontWeight: '600',
            fontSize: '1.3rem',
            border: '2px solid rgba(255, 215, 0, 0.3)',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(255, 215, 0, 0.3)',
            minWidth: '200px',
            textAlign: 'center',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 215, 0, 0.5)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 215, 0, 0.3)';
          }}
        >
          Група дівчат
        </Link>
      </div>
    </div>
  );
};
